import React from 'react'
import reactStamp from 'react-stamp'
import req from 'reqwest';
import Appointments from '../components/Appointments'
import TestPractitioners from 'json!../../www/resources/practitioners-portal-response.json'
import TestUpcomingAppointments from 'json!../../www/resources/appointments-upcoming.json'
import TestAppointmentsHistory from 'json!../../www/resources/appointments-history.json'
import TestDaysWithFreeSlots from 'json!../../www/resources/appointments-schedule2.json'

export default reactStamp(React).compose({

    init(){
        this.getCareProvidersInfo();
        this.getUpcomingAppointments(sessionStorage.getItem("id"));
        this.getAppointmentsHistory(sessionStorage.getItem("id"));
        this.activateBooking = this.activateBooking.bind(this);
        this.activateHistory = this.activateHistory.bind(this);
        this.getAppointmentsHistory = this.getAppointmentsHistory.bind(this);
        this.getUpcomingAppointments = this.getUpcomingAppointments.bind(this);
        this.handleProviderSelect = this.handleProviderSelect.bind(this);
        this.putSchedule = this.putSchedule.bind(this);
        this.state.active = 'history';
    },

    state: {},

    render() {
        return (
            <Appointments
                active={this.state.active}
                activateHistory={this.activateHistory}
                activateBooking={this.activateBooking}
                practitioners={this.state.practitioners}
                upcomingAppointments={this.state.upcomingAppointments}
                appointmentsHistory={this.state.appointmentsHistory}
                handleProviderSelect={this.handleProviderSelect}
                daysWithFreeSlots={this.state.daysWithFreeSlots}
                putSchedule={this.putSchedule}
            />
        );
    },

    activateHistory(){
        this.setState({active: "history"});
    },

    activateBooking(){
        this.setState({active: "booking"});
    },

    getCareProvidersInfo() {
        req({
            url: "https://portal-experience-api.cloudhub.io/api/practitioners",
            method: 'GET',
            crossOrigin: true,
        })
            .then((resp) => this.handleGetProvidersResponse(resp))
            .fail((err, msg) => this.handleGetProvidersError(err, msg))
            .always((resp) => {
            })
    },

    handleGetProvidersResponse(resp){
        this.setState({practitioners: resp})
    },

    handleGetProvidersError(err, msg){
    },

    getAppointmentsHistory(id) {
        req({
            url: "https://portal-experience-api.cloudhub.io/api/patient/" + id + "/appointments/history",
            method: 'GET',
            crossOrigin: true,
        })
            .then((resp) => this.handleGetAppointmentsHistoryResponse(resp))
            .fail((err, msg) => this.handleGetAppointmentsHistoryError(err, msg))
            .always((resp) => {
            })
    },

    handleGetAppointmentsHistoryResponse(resp){
        this.setState({appointmentsHistory: resp})
    },

    handleGetAppointmentsHistoryError(err, msg){
    },

    getUpcomingAppointments(id) {
        req({
            url: "https://portal-experience-api.cloudhub.io/api/patient/" + id + "/appointments/upcomming",
            method: 'GET',
            crossOrigin: true
        })
            .then((resp) => this.handleGetUpcomingAppointmentsResponse(resp))
            .fail((err, msg) => this.handleGetUpcomingAppointmentsError(err, msg))
            .always((resp) => {
            })
    },

    handleGetUpcomingAppointmentsResponse(resp){
        this.setState({upcomingAppointments: resp})
    },

    handleGetUpcomingAppointmentsError(err, msg){
    },

    handleProviderSelect(id) {
        req({
            url: "https://portal-experience-api.cloudhub.io/api/practitioners/" + id + "/schedule",
            method: 'GET',
            crossOrigin: true,
        })
            .then((resp) => this.handleGetDaysWithFreeSlotsResponse(resp))
            .fail((err, msg) => this.handleGetDaysWithFreeSlotsError(err, msg))
            .always((resp) => {
            })
    },

    handleGetDaysWithFreeSlotsResponse(resp){
        this.setState({daysWithFreeSlots: resp})
    },

    handleGetDaysWithFreeSlotsError(err, msg){
    },

    putSchedule(data, callback) {
        let id = sessionStorage.getItem("id");
        req({
            url: "https://portal-experience-api.cloudhub.io/api/patient/" + id + "/appointments",
            method: 'POST',
            contentType: "application/json",
            crossOrigin: true,
            data: JSON.stringify(data)
        })
            .then((resp)=>this.handlePutScheduleResponse(resp, callback))
            .fail((err, msg) => this.handlePutScheduleError(err, msg, callback))
            .always((resp) => {
            })
    },

    handlePutScheduleResponse(resp, callback){
        console.log(resp)
        callback();
    },

    handlePutScheduleError(err, msg, callback){
        callback();
    },


});


/** WEBPACK FOOTER **
 ** ./src/app/containers/Appointments.js
 **/